import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ConnectedProps, connect } from "react-redux";
import { asyncRoutes as economyRoutes } from "us.collection.economy/routes";
import Common from "us.common";
import { ConfigurationProvider } from "us.common/ConfigurationContext";
import collectionRoutes from "us.collection/routes";
import commonRoutes from "us.common/routes";
import { SignalRProvider } from "us.common/SignalRProvider";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { RootState } from "us.helper/types";
import { DrawerProvider } from "us.common/context";
import { useAuth } from "us.helper/hooks/useAuth";
import { Loader, LoginRedirect } from "us.common/components";

const { Page404, AppLayout, ConfigProvider } = Common.Components;

interface IAppProps {
  msalInstance: any;
}

const App: React.FC<IAppProps & PropsFromRedux> = ({ currentLanguage }) => {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) return <Loader />;

  if (!isAuthenticated) {
    return (
      <UnauthenticatedTemplate>
        <BrowserRouter
          future={{
            v7_relativeSplatPath: true,
          }}
        >
          <LoginRedirect />
        </BrowserRouter>
      </UnauthenticatedTemplate>
    );
  }

  return (
    <AuthenticatedTemplate>
      <BrowserRouter
        future={{
          v7_relativeSplatPath: true,
        }}
      >
        <ConfigurationProvider>
          <SignalRProvider>
            <DndProvider backend={HTML5Backend}>
              <DrawerProvider>
                <AppLayout>
                  <ConfigProvider locale={currentLanguage as any}>
                    <Routes>
                      {[
                        ...collectionRoutes(-1),
                        ...economyRoutes,
                        ...commonRoutes,
                      ]}
                      <Route path="*" element={<Page404 />} />
                    </Routes>
                  </ConfigProvider>
                </AppLayout>
              </DrawerProvider>
            </DndProvider>
          </SignalRProvider>
        </ConfigurationProvider>
      </BrowserRouter>
    </AuthenticatedTemplate>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    currentLanguage: state.common.currentLanguage,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(App);
